module.exports = __webpack_public_path__ + "ui-static/img/lines-no-items_light.d4a707c3.svg";